export default __webpack_public_path__ + "static/media/trading.5a2676da.svg";